import type { FC, SVGAttributes } from 'react';
import React from 'react';

export const IconShortArrow: FC<SVGAttributes<SVGElement>> = props => (
    <svg height="15" viewBox="0 0 9 15" width="9" {...props}>
        <path
            clipRule="evenodd"
            d="M7.757 14.353c.402-.405.42-1.08.042-1.508L3.112 7.542 7.8 2.24A1.117 1.117 0 007.757.732a.957.957 0 00-1.413.045L1.01 6.81a1.119 1.119 0 000 1.463l5.334 6.034a.957.957 0 001.413.045z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
